$(function() {
	const $doc = $(document);

	$doc.on('blur', '[name="date"], [name="time_period"], [name="memo"]', setNoteValue);
	$doc.on('change', '[name="date"], [name="time_period"], [name="memo"]', setNoteValue);
	$doc.on('change', '[name="age_check"]', onChangeAgeCheck);

	initCart();
})

/**
 * トップページ初期化処理
 */
function initCart() {
	initUserRequestDate();
	setNoteValue();
	setAgeCheckStatus();
}

/**
 * 「お届け希望日」フィールドを初期化
 */
function initUserRequestDate() {
    let minDate = new Date();
    let maxDate = new Date();

    // 「今日が5/20なら5/25～6/23まで選択可能」を実現する値を設定
  
    // 最短5日後の日付をセット
    minDate.setDate(minDate.getDate() + 5);

    // 5日後からさらに30日後の日付をセット
    maxDate.setDate(maxDate.getDate() + 34);

    // プルダウンを生成
    const selectDate = $('#userRequestDate');
    selectDate.append($('<option>').text('指定なし'));

    while (minDate <= maxDate) {
        const formattedDate = formatDate(minDate);
        selectDate.append($('<option>').val(formattedDate).text(formattedDate));
        minDate.setDate(minDate.getDate() + 1);
    }

    function formatDate(date) {
        const y = date.getFullYear();
        const m = ('0' + (date.getMonth() + 1)).slice(-2);
        const d = ('0' + date.getDate()).slice(-2);
		const weekdays = { weekday: 'short', timeZone: 'Asia/Tokyo' };
		const w = date.toLocaleString('ja-JP', weekdays);
        return `${y}年${m}月${d}日(${w})`;
    }
}

/**
 * 隠し要素[name="note"]に値をセット
 */
function setNoteValue() {
	const date = $('[name="date"]').val();
	const timePeriod = $('[name="time_period"] :selected').val();
	const memo = $('[name="memo"]').val();

	const strArray = [];
	// お届け希望日
	const dateStr = date === ''? '指定なし': date;
	strArray.push('【お届け希望日】' + dateStr);
	// お届け希望時間帯
	strArray.push('【お届け希望時間帯】' + timePeriod);
	// 要望
	const memoStr = memo === ''? 'なし': memo;
	strArray.push('【要望】' + memoStr);

	// 追加情報を１つの文字列に結合
	const noteVal = strArray.join("\n");

	// 隠しフォームパーツに値をセット
	$('[name="note"]').val(noteVal);
}

/**
 * 年齢確認の必要性有無をセット
 */
function setAgeCheckStatus() {
	// カートに商品がない場合は処理終了
	if ($('.cart-item').length === 0) {
		return false;
	}

	// 年齢確認が必要な商品がカート内にある時はボタンを非活性化させ、注意書きを表示
	if ($('.age_check_required').length > 0) {
		$('.age_check_section').show();
		$('#checkout').prop('disabled', true);
	} else {
		$('.age_check_section').hide();
		$('#checkout').prop('disabled', false);
	}
}

/**
 * 年齢認証チェックボックス変更時処理
 */
function onChangeAgeCheck() {
	if ($(this).prop('checked')) {
		// 年齢確認チェック時はボタンを活性化
		$('#checkout').prop('disabled', false);
	} else {
		// 年齢確認アンチェック時はボタンを非活性化
		$('#checkout').prop('disabled', true);
	}
}